import React from 'react'
import './style.css'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import Header from './header/container'
import Home from './home/container'
import Imagens from './imagens/container'
import Empreendimento from './empreendimento/container'
import SaibaComo from './como/container'
import Contato from './contato/container'
import Mapa from './mapa/container'
import Rodape from './rodape/component'
import Reminder from './reminder/container'



import { Route, Link, Switch } from "react-router-dom";

export default (props) =>{
    return(
        <div className='web-site-out-wrapper'>
            <Header/>
            <div className='page_content'>
                <Switch>
                    <Route path='/' exact component={Home}/>
                    <Route path='/empreendimento' component={Empreendimento} />
                    <Route path='/saiba_como' component={SaibaComo} />
                    <Route path='/contato' component={Contato}/>
                    <Route path='/imagens' component={Imagens}/>
                    <Route path='/mapa' component={Mapa}/>
                </Switch>
            </div>
            <Reminder/>
            <Rodape/>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/views/website/component.js